<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PublicLayout from './PublicLayout.vue';
import AdminLayout from './AdminLayout.vue';
import BlankLayout from './BlankLayout.vue';

const route = useRoute();

const layoutComponent = computed(() => {
  const layout = route.meta.layout as string | undefined;
  if (layout === 'admin') return AdminLayout;
  if (layout === 'blank') return BlankLayout;
  return PublicLayout;
});
</script>

<template>
  <component :is="layoutComponent">
    <RouterView />
  </component>
</template>
